import { render, staticRenderFns } from "./environmentalReportTable.vue?vue&type=template&id=3e50c962"
import script from "./environmentalReportTable.vue?vue&type=script&lang=js"
export * from "./environmentalReportTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports